import { useMutation } from '@tanstack/react-query'
import { BillingApiClient } from '../services'
import { useCurrentUser } from '~/hooks'

export function useCreateSubscription(workspaceId: string) {
  const user = useCurrentUser()

  return useMutation({
    mutationFn: async () => {
      const { url } = await BillingApiClient.generateCheckoutSession(workspaceId, {}, user.email)
      window.location.href = url
      return
    },
  })
}
